<div class="menu">
  <span class="menu-heading">
    Interaction {{ interactionDetailedData?.InteractionID }} -
    {{ interactionDetailedData?.Agent }}
    <span *ngIf="showSurveyDetails">
      | {{ newName }} {{ selectedType?.Name }} Survey {{ selectedSurvey?.SurveyID }} - Reviewer:
      {{ userDetails?.FirstName + ' ' + userDetails?.LastName }}
    </span>
  </span>
  <span class="close" (click)="closeTaskSelectionMenu()">X</span>
</div>
<div class="row m-0">
  <div class="verticalScroll verticalBorder" [ngStyle]="{ width: isAudit ? '49%' : '100%' }">
    <!-- [ngStyle]="{ width: showAudit ? '100%' : isAudit ? '49%' : '100%' }"
        [ngClass]="{ verticalBorder: isAudit }" -->

    <div class="accordion accordion-flush">
      <div class="accordion-item" id="accordionOne" *ngIf="showAudioTab">
        <h2
          class="accordion-header accordion-button section-heading"
          data-bs-toggle="collapse"
          data-bs-target="#collapseOne"
          aria-expanded="true"
          aria-controls="collapseOne"
        >
          RECORDING
        </h2>
        <hr class="solid-headerDivider" />

        <div id="collapseOne" class="accordion-collapse collapse show accordian-padb" data-bs-parent="#accordionOne">
          <div class="accordion-body">
            <div class="align-center" *ngIf="showHeader">
              <div class="headerdiv">
                <div
                  class="tab-heading"
                  *ngFor="let tab of recordingTab; let i = index"
                  [ngClass]="tab.isSelected ? 'tab-heading-focus' : ''"
                  (click)="TabSelectionChange(tab.index)"
                >
                  {{ tab.label }}
                </div>
              </div>
            </div>
            <div *ngIf="selectedTab == 'Audio'">
              <div class="recHeading" *ngIf="!showHeader">Audio</div>
              <hr class="mb-1 solid-headerDivider" *ngIf="!showHeader" />
              <div *ngIf="showRecOptions == true && recordingsArray.length > 0" class="recFont">
                <label for="" class="field-label"> Recording</label>

                <select [(ngModel)]="selectedRecordingValue" (change)="changeRecording($event)" class="field-label">
                  <option *ngFor="let item of recordingsArray; let i = index" [ngValue]="item" [selected]="item">
                    {{ i + 1 }}
                  </option>
                </select>
                of {{ recordingsArray.length }}
              </div>
              <!-- <div class="record" *ngIf="isRecordLoaded"> -->
              <div class="record" [ngStyle]="{ width: isAudit ? '26rem' : '100%' }" *ngIf="isRecordLoaded">
                <app-videojs-wavesurfer [recordingDetails]="recordingDetails"   [filename]="audiofilename"></app-videojs-wavesurfer>
              </div>
            </div>
            <div *ngIf="selectedTab == 'AgentDesktop'">
              <div class="recHeading" *ngIf="!showHeader">Agent Desktop</div>
              <hr class="mb-1 solid-headerDivider" *ngIf="!showHeader" />
              <div *ngIf="showVideoRecOptions == true && videoRecordingsArray.length > 1" class="recFont">
                <label for="" class="field-label"> Recording</label>

                <select [(ngModel)]="selectedVideoRec" (change)="changeVideoRecording($event)" class="field-label">
                  <option *ngFor="let item of videoRecordingsArray; let i = index" [ngValue]="item" [selected]="item">
                    {{ i + 1 }}
                  </option>
                </select>
                of {{ videoRecordingsArray.length }}
              </div>
              <!-- <div class="record" *ngIf="isRecordLoaded"> -->
              <div class="record" [ngStyle]="{ width: isAudit ? '26rem' : '100%' }" *ngIf="isVideoRecordLoaded">
                <app-videojs-wavesurfer
                  [recordingDetails]="videoRecordingfile"
                  [IsAudio]="false"
                  [filename]="filename"
                ></app-videojs-wavesurfer>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="accordion-item" id="accordionSix" *ngIf="isTranscript">
        <h2
          class="accordion-header accordion-button section-heading"
          data-bs-toggle="collapse"
          data-bs-target="#collapseSix"
          aria-expanded="true"
          aria-controls="collapseSix"
        >
          TRANSCRIPT AND INSIGHTS
        </h2>
        <hr class="solid-headerDivider" />

        <div id="collapseSix" class="accordion-collapse collapse accordian-padb" data-bs-parent="#accordionSix">
          <div class="accordion-body">
            <div class="record" [ngStyle]="{ width: isAudit ? '26rem' : '100%' }">
              <app-call-transcript></app-call-transcript>
            </div>
          </div>
        </div>
      </div>
      <div class="accordion-item" id="accordionTwo">
        <h2
          class="accordion-header accordion-button section-heading"
          data-bs-toggle="collapse"
          data-bs-target="#collapseTwo"
          aria-expanded="true"
          aria-controls="collapseTwo"
        >
          INTERACTION DETAILS
        </h2>
        <hr class="solid-headerDivider" />
        <!-- <h2 class="accordion-header">
                      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                          data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                          INTERACTION DETAILS
                      </button>
                  </h2> -->
        <div id="collapseTwo" class="accordion-collapse collapse accordian-padb" data-bs-parent="#accordionTwo">
          <div class="accordion-body">
            <table class="table">
              <tbody>
                <tr>
                  <td class="info-label">Interaction ID</td>
                  <td class="info-value">{{ interactionDetailedData?.InteractionID }}</td>
                </tr>
                <tr>
                  <td class="info-label">CaseID</td>
                  <td class="info-value">{{ interactionDetailedData?.CaseIds }}</td>
                </tr>
                <tr>
                  <td class="info-label">Interaction Type</td>
                  <td class="info-value">{{ interactionDetailedData?.InteractionType }}</td>
                </tr>
                <tr>
                  <td class="info-label">Queue</td>
                  <td class="info-value">{{ interactionDetailedData?.Queue }}</td>
                </tr>
                <tr>
                  <td class="info-label">Disposition</td>
                  <td class="info-value">{{ interactionDetailedData?.Disposition }}</td>
                </tr>
                <tr>
                  <td class="info-label">Disposition Type</td>
                  <td class="info-value">{{ interactionDetailedData?.DispositionType }}</td>
                </tr>
                <tr>
                  <td class="info-label">Request Type</td>
                  <td class="info-value">{{ interactionDetailedData?.RequestType }}</td>
                </tr>
                <tr>
                  <td class="info-label">Agent</td>
                  <td class="info-value">{{ interactionDetailedData?.Agent }}</td>
                </tr>
                <tr>
                  <td class="info-label">Group</td>
                  <td class="info-value">{{ interactionDetailedData?.Group }}</td>
                </tr>
                <tr>
                  <td class="info-label">Manager</td>
                  <td class="info-value">{{ interactionDetailedData?.Manager }}</td>
                </tr>
                <tr>
                  <td class="info-label">User ID</td>
                  <td class="info-value">{{ interactionDetailedData?.UserID }}</td>
                </tr>
                <tr>
                  <td class="info-label">CRM User ID</td>
                  <td class="info-value">{{ interactionDetailedData?.CrmUserID }}</td>
                </tr>
                <!-- <tr>
                  <td class="info-label">CaseID</td>
                  <td class="info-value">{{ interactionDetailedData?.CaseID }}</td>
                </tr> -->
                <tr>
                  <td class="info-label">User Name</td>
                  <td class="info-value">{{ interactionDetailedData?.User }}</td>
                </tr>
                <tr>
                  <td class="info-label">User Phone Number</td>
                  <td class="info-value">{{ interactionDetailedData?.PhoneNumber }}</td>
                </tr>
                <tr>
                  <td class="info-label">Call Started</td>
                  <td class="info-value">{{ startedDate }}</td>
                </tr>
                <tr>
                  <td class="info-label">Queued</td>
                  <td class="info-value">{{ queuedDate }}</td>
                </tr>
                <tr>
                  <td class="info-label">Answered</td>
                  <td class="info-value">{{ answeredDate }}</td>
                </tr>
                <tr>
                  <td class="info-label">Call Ended</td>
                  <td class="info-value">{{ endedDate }}</td>
                </tr>
                <tr>
                  <td class="info-label">Call Submitted</td>
                  <td class="info-value">{{ submittedDate }}</td>
                </tr>
                <tr>
                  <td class="info-label">Follow-Up Type</td>
                  <td class="info-value">{{ interactionDetailedData?.FollowUpType }}</td>
                </tr>
                <tr>
                  <td class="info-label">Follow-Up Date</td>
                  <td class="info-value">{{ followUpDate }}</td>
                </tr>
                <tr>
                  <td class="info-label">Comments</td>
                  <td class="info-value" [innerHTML]="interactionDetailedData?.Comments"></td>
                </tr>
                <tr>
                  <td class="info-label">Dialer Bypassed</td>
                  <td class="info-value">{{ interactionDetailedData?.DialerBypassed }}</td>
                </tr>
                <tr>
                  <td class="info-label">Bypass Explanation</td>
                  <td class="info-value">{{ interactionDetailedData?.BypassExplanation }}</td>
                </tr>
                <tr>
                  <td class="info-label">Time in IVR</td>
                  <td class="info-value">{{ ivrTime }}</td>
                </tr>
                <tr>
                  <td class="info-label">Time in Queue</td>
                  <td class="info-value">{{ queueTime }}</td>
                </tr>
                <tr>
                  <td class="info-label">Time with CSR</td>
                  <td class="info-value">{{ csrTime }}</td>
                </tr>
                <tr>
                  <td class="info-label">Handling Time</td>
                  <td class="info-value">{{ interactionDetailedData?.HandlingTime }}</td>
                </tr>
                <tr>
                  <td class="info-label">Total Hold Time</td>
                  <td class="info-value">{{ interactionDetailedData?.TotalHoldTime }}</td>
                </tr>
                <tr>
                      <td class="info-label">Total Hold Time</td>
                      <td class="info-value">{{ interactionDetailedData?.TotalHoldTime }}
                      </td>
                </tr>
                <ng-container *ngIf="interactionDetailedData?.HoldIntervals?.length > 0">
                  <tr>
                    <td colspan="2" style="text-align: center;">
                      <label class="info-label-heading">Hold Intervals</label>
                      <table class="hold-interval-table" cellpadding="5" cellspacing="0" style="margin-left: auto; margin-right: auto;">
                          <thead>
                              <tr>
                                  <th>Seq No</th>
                                  <th>Start Time</th>
                                  <th>End Time</th>
                                  <th>Duration (sec)</th>
                              </tr>
                          </thead>  
                          <tbody>
                              <tr *ngFor="let hold of interactionDetailedData?.HoldIntervals">
                                  <td>{{ hold.HoldSeqNo }}</td>
                                  <td>{{ hold.HoldStartTime | date:'HH:mm:ss a' }}</td>
                                  <td>{{ hold.HoldEndTime | date:'HH:mm:ss a' }}</td>
                                  <td>{{ hold.HoldDurationSec }}</td>
                              </tr>
                          </tbody>
                      </table>
                    </td>
                  </tr>   
                </ng-container>             
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div class="accordion-item" id="accordionThree">
        <h2
          class="accordion-header accordion-button section-heading"
          data-bs-toggle="collapse"
          data-bs-target="#collapseThree"
          aria-expanded="true"
          aria-controls="collapseThree"
        >
          USER INFORMATION
        </h2>
        <hr class="solid-headerDivider" />
        <!-- <h2 class="accordion-header">
                      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                          data-bs-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                          USER INFORMATION
                      </button>
                  </h2> -->
        <div id="collapseThree" class="accordion-collapse collapse accordian-padb" data-bs-parent="#accordionThree">
          <div class="accordion-body">
            <table class="table">
              <tbody>
                <ng-container *ngIf="interactionUserDataKeys?.length; else noData">
                  <tr *ngFor="let key of interactionUserDataKeys">
                    <td class="info-label">{{ key }}</td>
                    <!-- Date-only fields -->
                    <td class="info-value" *ngIf="useDateOnlyPipe(key); else dateWithTime">
                       {{ interactionUserData[key] | custdatenotimeconversion }}
                    </td>
                    <!-- Date with time -->
                    <ng-template #dateWithTime>
                    <td class="info-value" *ngIf="isDateValue(interactionUserData[key]); else normal">
                      {{ interactionUserData[key] | custdate }}
                    </td>
                    </ng-template>
                   
                    <ng-template #normal>
                      <td class="info-value"  [innerHTML]="interactionUserData[key]">
                       
                      </td>
                    </ng-template>
                  </tr>
                </ng-container>
                <!-- <tr>
                                  <td class="info-label">Role</td>
                                  <td class="info-value">{{ interactionUserData?.Role }}</td>
                                </tr>
                                <tr>
                                  <td class="info-label">ShortVanityID</td>
                                  <td class="info-value">{{ interactionUserData?.ShortVanityID }}</td>
                                </tr>
                                <tr>
                                  <td class="info-label">CrmUserID</td>
                                  <td class="info-value">{{ interactionUserData?.CrmUserID }}</td>
                                </tr>
                                <tr>
                                  <td class="info-label">FirstName</td>
                                  <td class="info-value">{{ interactionUserData?.FirstName }}</td>
                                </tr>
                                <tr>
                                  <td class="info-label">LastName</td>
                                  <td class="info-value">{{ interactionUserData?.LastName }}</td>
                                </tr>
                                <tr>
                                  <td class="info-label">EmailAddress</td>
                                  <td class="info-value">{{ interactionUserData?.EmailAddress }}</td>
                                </tr>
                                <tr>
                                  <td class="info-label">Address1</td>
                                  <td class="info-value">{{ interactionUserData?.Address1 }}</td>
                                </tr>
                                <tr>
                                  <td class="info-label">Address2</td>
                                  <td class="info-value">{{ interactionUserData?.Address2 }}</td>
                                </tr>
                                <tr>
                                  <td class="info-label">City</td>
                                  <td class="info-value">{{ interactionUserData?.City }}</td>
                                </tr>
                                <tr>
                                  <td class="info-label">Country</td>
                                  <td class="info-value">{{ interactionUserData?.Country }}</td>
                                </tr>
                                <tr>
                                  <td class="info-label">UserID</td>
                                  <td class="info-value">{{ interactionUserData?.UserID }}</td>
                                </tr>
                                <tr>
                                  <td class="info-label">PhoneNumbers</td>
                                  <td class="info-value">{{ interactionUserData?.PhoneNumbers }}</td>
                                </tr> -->
              </tbody>
            </table>
            <ng-template #noData>
              <tr>
                <td colspan="2" class="text-center">No data available</td>
              </tr>
            </ng-template>
          </div>
        </div>
      </div>

      <!--<div class="accordion-item" id="accordionFive" *ngIf="isTranscript">
                <h2 class="accordion-header accordion-button section-heading"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseFive"
                    aria-expanded="true"
                    aria-controls="collapseFive">
                    TRANSCRIPT AND INSIGHTS
                </h2>
                <hr class="solid-headerDivider" />

                <div id="collapseFive" class="accordion-collapse collapse accordian-padb" data-bs-parent="#accordionFive">
                    <div class="accordion-body">
                        <div class="row">
                            <div class="col-12">
                                <div class="container"
                                     style="
                      text-align: left;
                      font-weight: 500;
                      font-size: 0.75rem;
                      line-height: 0.875rem;
                      font-family: Gellix, sans-serif;
                      letter-spacing: 0rem;
                      color: #53565a;
                      opacity: 1;
                    ">
                                    <app-call-transcript></app-call-transcript>
                                </div>
                            </div>
                        </div>
                        <ng-template #noData>
                            <tr>
                                <td colspan="2" class="text-center">No data available</td>
                            </tr>
                        </ng-template>
                    </div>
                </div>
            </div>-->
    </div>
  </div>

  <div class="col-6 verticalScroll" *ngIf="isAudit">
    <!-- <div class="col-6 verticalScroll" *ngIf="showAudit == false"> -->
    <div class="accordion accordion-flush">
      <div class="accordion-item" id="accordionFour">
        <!-- <div *ngIf="isAuditor == true"> -->
          <div *ngIf="isAuditor || noGrantAuditView">
      
        <h2
          class="accordion-header accordion-button section-heading"
          data-bs-toggle="collapse"
          data-bs-target="#collapseFour"
          aria-expanded="true"
          aria-controls="collapseFour"
        >
          AUDITS
        </h2>
        <hr class="solid-headerDivider" />
        <!-- <h2 class="accordion-header">
                            <button class="accordion-button" type="button" data-bs-toggle="collapse"
                                data-bs-target="#collapseFour" aria-expanded="true" aria-controls="collapseFour">
                               AUDITS
                            </button>
                        </h2> -->
        <div id="collapseFour" class="accordion-collapse collapse show" data-bs-parent="#accordionFour">
          <div class="accordion-body">
            <div class="auditForm">
              <div class="row" *ngIf="isAuditor && !noGrantAuditView">
                <div class="col-2 formFont field-label audit-field-label">Forms:</div>
                <div class="col-9" style="padding-left: 0.5rem">
                  <select
                    name="page"
                    class="audit-dropdown"
                    [(ngModel)]="selectedForm"
                    (change)="changeFormField($event)"
                    style="width: 93%"
                  >
                    <ng-container *ngFor="let item of filteredAuditArray; let i = index">
                      <option [ngValue]="item" [selected]="item.Name == this.selectedForm">
                        {{ item.Name }}
                      </option>
                    </ng-container>
                  </select>
                  <!-- <select [(ngModel)]="selectedForm" (change)="changeFormField($event)">
                                                          <option [selected]='auditForm.Name' value={{auditForm.Name}} *ngFor="let auditForm of filteredAuditArray">{{auditForm.Name}}</option>
                                                      </select></div> -->
                  <div class="col-2"></div>
                </div>
                <div class="row" *ngIf="isAuditor && !noGrantAuditView">
                  <div class="col-2 field-label audit-field-label">Types:</div>
                  <!-- <div class="col-9">
                    <select (change)="getSelectedType($event)">
                      <option
                        *ngFor="let item of selectedTypeArray; let i = index"
                        [ngValue]="item"
                        [selected]="item.Name == this.selectedType?.Name"
                      >
                        {{ item.Name }}
                      </option>
                    </select>
                  </div> -->
                  <div class="col-9">
                    <select [(ngModel)]="selectedType" [ngModelOptions]="{ standalone: true }">
                      <option *ngFor="let item of selectedTypeArray" [ngValue]="item">
                        {{ item.Name }}
                      </option>
                    </select>
                  </div>
                  <div
                    class="col-1 openIcon"
                    [ngClass]="filteredAuditArray ? '' : 'disabled-content'"
                    (click)="createNewAuditSurvey(true)"
                  >
                    <img alt="" class="icons" src="{{ baseHref }}/assets/images/icon-new-folder.svg" /><span>New</span>
                  </div>
                </div>
              </div>
                <hr class="light-divider" />
                <div class="row" *ngIf="showOpenSurvey">
                  <div class="col-2 field-label audit-field-label">Surveys:</div>
                  <div class="col-9">
                    <!-- <select>
                      <option
                        *ngFor="let item of selectedSurveyArray; let i = index"
                        [ngValue]="item"
                        [selected]="item.SurveyID == this.selectedSurvey.SurveyID"
                      >
                        {{ item.SurveyID + ':' + selectedForm.Name + '-' + item?.Type?.Name }}({{ item.Status.Name }})
                      </option>
                    </select> -->
                    <select [(ngModel)]="selectedSurvey" [ngModelOptions]="{ standalone: true }">
                      <option *ngFor="let item of selectedSurveyArray" [ngValue]="item">
                         {{ item.SurveyID + ':' + (item.__FormName || selectedForm?.Name) + '-' + item?.Type?.Name }} ({{ item.Status.Name }})
                         <!-- {{ item.SurveyID + ':' + selectedForm.Name + '-' + item?.Type?.Name }} ({{ item.Status.Name }}) -->
                      </option>
                    </select>
                  </div>
                  <div class="col-1 openIcon" (click)="openAuditSurvey()">
                    <img alt="" class="icons" src="{{ baseHref }}/assets/images/icon-open-folder.svg" />Open
                  </div>
                </div>
              <!-- </div> -->
            </div>
          </div>
        </div>
      </div>
        <div class="accordion-item" id="accordionFive" *ngIf="isSubmitted">
          <div class="row m-0">
            <div
              class="accordion-header accordion-button accordian-section"
              data-bs-toggle="collapse"
              data-bs-target="#collapseFive"
              aria-expanded="true"
              aria-controls="collapseFive"
            >
              <div class="col-6 section-heading">{{ newSurveyData.Name }}</div>
              <div class="col-4 disp-flex">
                <div class="col-7">
                  <span class="submitBtn">{{ surveySections.sectionLabelStatus }}</span>
                </div>
                <div class="col-5">
                  <div class="nonHeader show-points">
                    ({{ surveySections.sectionTotal }}/{{ surveySections.totalSectionPoints }})
                  </div>
                </div>
              </div>
              <div class="col-2 nonHeader show-points show-perc"> 
                {{ surveySections.totalSectionScore % 1 === 0
                  ? surveySections.totalSectionScore
                  : (surveySections.totalSectionScore | number:'1.2-2') }}%</div>
            </div>
          </div>

          <hr class="solid-headerDivider" />
          <div id="collapseFive" class="accordion-collapse collapse show" data-bs-parent="#accordionFive">
            <div class="accordion accordion-flush">
              <div class="accordion-body" *ngFor="let sectionItems of surveySections; let i = index">
                <div class="accordion-item" id="accordion{{ i }}">
                  <div class="row m-0 sub-heading">
                    <div
                      class="accordion-header accordion-button subService"
                      data-bs-toggle="collapse"
                      [attr.data-bs-target]="'#collapse' + i"
                      aria-expanded="true"
                      [attr.aria-controls]="'collapse' + i"
                    >
                      <div class="col-6 sub-section-heading">{{ sectionItems.Name }}</div>

                      <div class="col-4 disp-flex">
                        <div class="col-7">
                          <span class="status-Btn">{{ sectionItems?.groupLabelStatus }}</span>
                        </div>
                        <div class="col-5">
                          <div class="show-points sub-points" id="showPoints" *ngIf="sectionItems?.showPoints == true">
                            ({{ sectionItems.Points }}/{{ sectionItems.Max }})
                          </div>
                        </div>
                      </div>
                      <div class="col-2 show-points show-perc" *ngIf="sectionItems?.showPoints == true">
                        {{ sectionItems.Score % 1 === 0 
                          ? sectionItems.Score 
                          : (sectionItems.Score | number:'1.2-2') }}%
                      </div>
                    </div>
                  </div>
                  <hr class="solid-divider" />

                  <div
                    id="collapse{{ i }}"
                    class="accordion-collapse collapse"
                    [attr.data-bs-parent]="'#accordion' + i"
                  >
                    <div class="accordion-body">
                      <div class="surveyForm">
                        <!-- <div class="row"  > -->
                        <!-- <div class="col-6 formFont"> -->
                        <div class="row form-row" *ngFor="let field of sectionItems.FieldGroup.Fields; let j = index">
                          <div class="col-8 input-data">
                            <div class="disp-grid">
                              <label for="" class="section-items"> *{{ field.Name }}</label>

                              <select
                                name="page{{ field.FieldID }}"
                                class="audit-dropdown"
                                [(ngModel)]="field.selectedFieldOption"
                                (change)="changeFieldOption($event, field.FieldOptions, i, field.selectedFieldOption)"
                              >
                                <option
                                  *ngFor="let fieldOptions of field.FieldOptions"
                                  [ngValue]="fieldOptions"
                                  [disabled]="surveySections?.sectionLabelStatus === 'Submitted' && !isSameAgent"
                                >
                                  {{ fieldOptions.Name }}
                                </option>
                              </select>
                            </div>
                          </div>
                          <div class="col-2 feedback-div">
                            <img alt="" class="feedback-img" src="{{ baseHref }}/assets/images/icon-star.png" />
                            <span class="feedback-val">{{ field?.selectedFieldOption?.ScoreValue }}</span>
                          </div>
                          <div class="col-2 feedback-div" (click)="showCommentBox(i, j)">
                            <img alt="" class="feedback-img" src="{{ baseHref }}/assets/images/icon-comment.png" />
                            <span class="feedback-val">{{ field?.commentValue }}</span>
                          </div>
                          <div *ngIf="field.showComments == true">
                            <div class="comments-heading">Comments</div>
                            <div class="comment-reviewer">
                              {{ userDetails?.FirstName + ' ' + userDetails?.LastName }}
                            </div>
                            <div class="textarea-outerpart">
                              <textarea
                                [(ngModel)]="field.Comments"
                                [disabled]="userEmail != surveyUserEmail"
                                (focusout)="onFocusOutEvent($event, i, j)"
                                rows="2"
                                cols="45"
                              ></textarea>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!--
                                          <div class="row mt-3">
                                              <div class="col-md-4" (click)="saveSurvey()"><button type="button"
                                                  class="btn exportBtn"> <img alt="" class="icons"
                                                      src="{{baseHref}}/assets/images/icon-audio-download.png">Save Changes
                                                  </button></div>
                                                  <div class="col-md-4" (click)="exportSurveyEcxcel()"><button type="button"
                                                      class="btn exportBtn"> <img alt="" class="icons"
                                                          src="{{baseHref}}/assets/images/ic">Delete</button></div>
                                              <div class="col-md-4" (click)="exportSurveyEcxcel()"><button type="button"
                                                      class="btn exportBtn"> <img alt="" class="icons"
                                                          src="{{baseHref}}/assets/images/icon-audio-download.png">Export
                                                      Excel</button></div>
                                          </div> -->
              <div class="mtb-10 button-container">
                <div class="disp-inline" *ngIf="showSaveBtn == true" (mousedown)="saveSurvey($event, false, saveLabel)">
                  <button type="button" class="btn saveBtn">
                    <img alt="" class="button-icons" src="{{ baseHref }}/assets/images/icon-save.svg" /><span
                      class="button-text"
                      >{{ saveLabel }}</span
                    >
                  </button>
                </div>
                <div class="disp-inline" *ngIf="showSubmitBtn == true" (mousedown)="saveSurvey($event, false, submitLabel)">
                  <button type="button" class="btn saveBtn">
                    <img alt="" class="button-icons" src="{{ baseHref }}/assets/images/icon-submit.svg" /><span
                      class="button-text"
                      >{{ submitLabel }}</span
                    >
                  </button>
                </div>
                <div class="disp-inline" *ngIf="showDeleteBtn == true" (mousedown)="saveSurvey($event, true, deleteLabel)">
                  <button type="button" class="btn delBtn">
                    <img alt="" class="button-icons" src="{{ baseHref }}/assets/images/icon-delete.svg" /><span
                      class="button-text"
                      >{{ deleteLabel }}</span
                    >
                  </button>
                </div>
                <div class="disp-inline" *ngIf="showExportBtn == true" (click)="getExportExcel()">
                  <button type="button" class="btn exportBtn">
                    <img alt="" class="button-icons" src="{{ baseHref }}/assets/images/icon-download.svg" /><span
                      class="button-text"
                      >{{ exportLabel }}</span
                    >
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
